import { cn } from '@/lib/utils';

/** Controle segmentado (ref. 02: Mês/Semana/Dia). Para alternar visões e filtros curtos. */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  className,
  label,
}: {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: string; count?: number }[];
  className?: string;
  label: string;
}) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn(
        'inline-flex h-9 items-center gap-0.5 rounded-full bg-canvas/60 p-1 shadow-[inset_0_0_0_1px_var(--color-line)]',
        className,
      )}
    >
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(o.value)}
            className={cn(
              'flex h-7 items-center gap-1.5 rounded-full px-3 text-[13px] whitespace-nowrap transition-colors',
              active
                ? 'bg-raised text-fg shadow-[0_1px_2px_rgb(0_0_0/0.4),inset_0_0_0_1px_var(--color-line)]'
                : 'text-fg-muted hover:text-fg',
            )}
          >
            {o.label}
            {o.count !== undefined && <span className="tabular text-[11.5px] text-fg-subtle">{o.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
